import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event14 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    কল্পনার শহর | CWIS mini-series | EP 3 | ACCOUNTABILITY | WaterAid | Gates Foundation
                  </h2>

                  

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                   শহর বদলে দেওয়ার শেষ ধাপ হল জবাবদিহিতা।
সত্যিকারের পরিবর্তন আসে তখনই, যখন স্যানিটেশন ব্যবস্থায় থাকে স্বচ্ছতা, অংশগ্রহণ আর বিশ্বাস।
দেখুন CWIS এনিমেটেড সিরিজের শেষ পর্ব ‘জবাবদিহিতা’, যেখানে দেখা যাবে শহরব্যাপী অন্তর্ভুক্তিমূলক স্যানিটেশন (বা সিটিওয়াইড ইনক্লুসিভ স্যানিটেশন/ CWIS) আওতায় দেয়া প্রতিশ্রুতি কিভাবে রূপ নেয় স্থায়ী পরিবর্তনে। <br /><br /> The final step in transforming cities is ensuring accountability.
Real change takes root when sanitation systems are built on transparency, participation, and trust.
Watch the final episode of the CWIS animated series ‘Accountability’ to see how commitments made under Citywide Inclusive Sanitation (CWIS) are being turned into lasting change.

                   <br /><br />
                   Video Link: <a
                      href="https://www.youtube.com/watch?v=9AJ4zOZdG94"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.youtube.com/watch?v=9AJ4zOZdG94
                    </a>
                  </p>
                  
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event14;
